import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { Dialog, DialogTitle, DialogContent, IconButton, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import EditAssetForm from './EditAssetForm';
import { getAssetDetail } from '../store/assetActions';

EditAssetModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  asset: PropTypes.object,
};

export default function EditAssetModal({ open, handleClose, asset }) {
  const dispatch = useDispatch();

  const handleSuccess = () => {
    // Refresh asset data after successful update
    if (asset?.id) {
      dispatch(getAssetDetail(asset.id));
    }
    handleClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      PaperProps={{
        sx: { minHeight: '600px' },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
        }}
      >
        Edit Asset
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        <Box sx={{ mt: 1 }}>
          <EditAssetForm isEdit fixedAsset={asset} onSuccess={handleSuccess} />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
